
// quantity-selector.js — PDP quantity +/- for product form
(function() {
  function clamp(val, min, max) {
    if (isNaN(val)) val = min || 1;
    if (!isFinite(max)) return Math.max(min || 1, val);
    return Math.min(max, Math.max(min || 1, val));
  }
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('[data-qty-plus],[data-qty-minus]');
    if (!btn) return;
    const wrap = btn.closest('.mitoq-qty');
    if (!wrap) return;
    const input = wrap.querySelector('.mitoq-qty__input');
    if (!input) return;
    const step = Number(input.getAttribute('step') || 1);
    const min = Number(input.getAttribute('min') || 1);
    const maxAttr = input.getAttribute('max');
    const max = maxAttr ? Number(maxAttr) : Infinity;
    let val = Number(input.value || 1);
    if (btn.hasAttribute('data-qty-plus')) val += step;
    else val -= step;
    input.value = clamp(val, min, max);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
